import { faClock, faRoute } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FmdBadRounded, HourglassBottomRounded, DownloadForOffline } from '@mui/icons-material';
import { Checkbox } from '@mui/material';
import { NavDropdown } from 'app/shared/layout/menus/menu-components';
import { IDashboardInfoRoutesDetailTruckImplement } from 'app/shared/model/dashboard-truck-implement-info.model';
import { RouteAddressType } from 'app/shared/model/enumerations/RouteAddressType.model';
import { PeriodicType } from 'app/shared/model/enumerations/periodicType';
import { convertDateTimeToPtBRWithYear, differenceBetweenTwoDates, formatIdleTime } from 'app/shared/util/date-utils';
import { Loading } from 'app/shared/util/loading';
import axios from 'axios';
import { format } from 'date-fns';
import { differenceInDays } from 'date-fns/esm';
import React, { Fragment, useEffect, useState } from 'react';
import { Button, Card, CardBody, Col, Collapse, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { IInfractions, IMapAlert, IRouteDetail, IRouteInfo, IRoutesCollapseProps } from '../../interface/dashboardTruckImplementInterface';

export const RoutesCollapse = (props: IRoutesCollapseProps) => {
  const [infoRouteDetail, setInfoRouteDetail] = useState<IRouteDetail>();
  const [cardIndex, setCardIndex] = useState<number>(null);
  const [verifyPeriod, setVerifyPeriod] = useState<PeriodicType | string>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [allInfractions, setAllInfractions] = useState<IInfractions[]>([]);
  const [allTypesInfractions, setAllTypesInfractions] = useState<IMapAlert[]>([]);
  const [filteredTypesInfractions, setFilteredTypesInfractions] = useState<string[]>([]);
  const [disableReportButton, setDisableReportButton] = useState<boolean>(false);
  const [showReportButton, setShowReportButton] = useState<boolean>(true);
  const showReportLoading = props.showReportLoading;

  function setFocusCard(index: number) {
    const element = document.querySelector('#container-popover');
    element.scrollTop = index * 50;
  }

  function initalState() {
    props.setListInfractions(null);
    setCardIndex(null);
    props.setInfoSubRoute({} as IRouteInfo);
    props.setStartIndex(null);
    props.setFinalIndex(null);
    props.setOnCenterMarkerPosition(null);
    props.setIdlePositions([]);
  }

  const getInfoRoute = (startDate: string, finalDate: string) => {
    try {
      axios
        .get<IDashboardInfoRoutesDetailTruckImplement>(
          `api/truck-implements/detailed-route/${props.implementId}/${new Date(startDate).toISOString()}/${new Date(finalDate).toISOString()}`,
          {
            params: { isBetaVersion: props.isBetaVersion },
          }
        )
        .then(response => {
          props.setLoadingInfo(false);
          setInfoRouteDetail(response.data.info);
          props.setListInfractions(response.data.infractions);
          props.setIdlePositions(response.data.info.idlePositions);
        });
    } catch (error) {
      setCardIndex(null);
    }
  };

  useEffect(() => {
    const startDate = new Date(props.routes[0].startDate);
    const endDate = new Date(props.routes[props.routes.length - 1].finalDate);

    const differenceBetweenDates = differenceInDays(endDate, startDate);

    if (differenceBetweenDates > 31) {
      setShowReportButton(false);
    }
  }, [showReportButton]);

  const getExcelFromInfoRoutes = () => {
    if (disableReportButton) {
      return;
    }

    const body = {
      routes: props.routes,
      positions: props.positions,
    };

    try {
      showReportLoading(true);
      setDisableReportButton(true);

      axios.post<Blob>(`api/export-to-excel/journey/${props.implementId}`, body, { responseType: 'blob' }).then(response => {
        const reportData = response.data;

        if (reportData) {
          const url = window.URL.createObjectURL(new Blob([reportData]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            'download',
            `REL_JORNADAS_PER.(${format(new Date(props.routes[0].startDate), 'dd.MM.yyyy')}-${format(
              new Date(props.routes[props.routes.length - 1].finalDate),
              'dd.MM.yyyy'
            )}).xlsx`
          );
          document.body.appendChild(link);
          link.click();
        }

        showReportLoading(false);
        setDisableReportButton(false);
      });
    } catch (error) {
      console.log(error);
      showReportLoading(false);
      setDisableReportButton(false);
    }
  };

  const filterSameArray = (array: IInfractions[]) => {
    const allAlerts = [];

    for (const infraction of array) {
      for (const alert of infraction.alerts) {
        allAlerts[alert.alertName] = allAlerts[alert.alertName] ? allAlerts[alert.alertName] + 1 : 1;
      }
    }

    const convertedArray = Object.keys(allAlerts).map(k => ({ label: k, value: allAlerts[k] }));
    return convertedArray;
  };

  const getInfractions = (startDate: string, finalDate: string) => {
    setAllTypesInfractions(null);
    try {
      axios
        .get<IInfractions[]>(`api/truck-implements/infractions/${props.implementId}/${new Date(startDate).toISOString()}/${new Date(finalDate).toISOString()}`)
        .then(response => {
          setAllInfractions(response.data);
          setAllTypesInfractions(filterSameArray(response.data) as any);
        });
    } catch (error) {
      setCardIndex(null);
    }
  };

  useEffect(() => {
    if (verifyPeriod !== props.periodType) {
      initalState();
    }
  }, [verifyPeriod, props.periodType]);

  const handleToggle = (id: number, routes: IRouteInfo) => {
    props.setListInfractions(null);
    if (cardIndex === id) {
      initalState();
    } else {
      setCardIndex(id);
      setVerifyPeriod(props.periodType);
      props.setInfoSubRoute(routes);
      props.setStartIndex(routes.startIndex);
      props.setFinalIndex(routes.finalIndex);
    }
  };

  const getPeriodFromInstants = (routes: IRouteInfo[]) => {
    const startDate = new Date(routes[0].startDate);
    const finalDate = new Date(routes[routes.length - 1].finalDate);
    const differenceBetweenDates = differenceInDays(new Date(finalDate), new Date(startDate));

    if (differenceBetweenDates <= 0) {
      return PeriodicType.TODAY;
    } else if (differenceBetweenDates <= 7) {
      return PeriodicType.WEEK;
    } else {
      return PeriodicType.MONTH;
    }
  };

  const dateTypeRendering = (startDate: string, finalDate: string, period: PeriodicType, routes: IRouteInfo[]) => {
    if ([PeriodicType.TODAY].includes(getPeriodFromInstants(routes))) {
      return `Nenhuma rota entre ${format(new Date(startDate), 'HH:mm')} e ${format(new Date(finalDate), 'HH:mm')}`;
    }
    if ([PeriodicType.WEEK].includes(getPeriodFromInstants(routes))) {
      if (period === PeriodicType.CUSTOM) {
        return `Nenhuma rota entre ${format(new Date(startDate), 'dd/MM')} e ${format(new Date(finalDate), 'dd/MM')}`;
      }
      return `Nenhuma rota em ${format(new Date(startDate), 'dd/MM')}`;
    }
    if ([PeriodicType.MONTH].includes(getPeriodFromInstants(routes))) {
      return `Nenhuma rota entre ${format(new Date(startDate), 'dd/MM')} e ${format(new Date(finalDate), 'dd/MM')}`;
    }
  };

  const filterInfractions = filteredInfractionss => {
    const newArray = [];
    allInfractions
      .filter(item => item.alerts.some(alert => filteredInfractionss.includes(alert.alertName)))
      .forEach(item => {
        item.alerts.forEach(alert => {
          if (filteredInfractionss.includes(alert.alertName)) {
            newArray.push({ lat: item.lat, lng: item.lng, alerts: [alert] });
          }
        });
      });
    props.setListInfractions(newArray);
    setIsOpen(prevOpen => !prevOpen);
  };

  const setAlertName = (checked: boolean, alertName: string) => {
    if (checked) {
      setFilteredTypesInfractions(prevType => [...prevType, alertName]);
    } else {
      setFilteredTypesInfractions(prevType => prevType.filter(item => item !== alertName));
    }
  };

  const filterTypesInfractions = (listInfractionss: IInfractions[]) => {
    const newArray = [];
    listInfractionss?.length &&
      listInfractionss.forEach(item => {
        item.alerts.forEach(alert => {
          !newArray.includes(alert.alertName) && newArray.push(alert.alertName);
        });
      });
    setFilteredTypesInfractions(newArray);
  };

  return (
    <NavDropdown id="drop-sub-routes" name="Rotas" align direction="up" disable={props.routes?.length ? false : true}>
      <Col id="container-popover" className="timeline">
        {props.routes.map((item: IRouteInfo, index: number) => (
          <ul key={index}>
            <li>
              <div className={`bullet + ${cardIndex === index && 'active'}`} />
              <div className="ml-4">
                <Card style={{ borderRadius: '8px' }}>
                  {item.startIndex === -1 ? (
                    <Button outline className="no-routes" disabled>
                      {dateTypeRendering(item.startDate, item.finalDate, props.periodType, props.routes)}
                    </Button>
                  ) : (
                    <Button
                      outline
                      onClick={() => handleToggle(index, item)}
                      disabled={props.loadingInfo}
                      active={cardIndex === index}
                      style={{
                        borderRadius: cardIndex === index ? '8px 8px 0 0' : '8px',
                        backgroundColor: cardIndex === index ? '#00EA80' : 'transparent',
                        color: cardIndex === index ? '#000814' : '#71757C',
                        borderColor: cardIndex === index ? '#00EA80' : '#71757C',
                      }}
                    >
                      <div className="container-info-routes">
                        <Col>
                          <FontAwesomeIcon icon={faRoute} />
                          {'Rota ' + (+index + 1)}
                        </Col>
                        <Col>
                          <FontAwesomeIcon icon={faClock} />
                          {differenceBetweenTwoDates(item.finalDate, item.startDate, true)}
                        </Col>
                        <Col>
                          <FmdBadRounded fontSize="small" />
                          {item.totalAlerts + ' Alerta' + (item.totalAlerts > 1 ? 's' : '')}
                        </Col>
                      </div>
                    </Button>
                  )}
                  <Collapse
                    onEntered={() => [props.setLoadingInfo(true), getInfoRoute(item.startDate, item.finalDate), setAllInfractions([])]}
                    isOpen={cardIndex === index}
                  >
                    <CardBody>
                      {infoRouteDetail && !props.loadingInfo ? (
                        <Fragment>
                          {cardIndex === index && setFocusCard(index)}
                          <dl style={{ fontSize: '13px' }} className="container-routes-collapse">
                            <div onClick={() => props.setOnCenterMarkerPosition(RouteAddressType.START)}>
                              <span>
                                <dt>Endereço de partida:</dt>
                                <dd>{infoRouteDetail.startPlace}</dd>
                              </span>
                              <div>
                                <img src="content/images/map-icons/icon_dot_start.png" alt="Ícone de partida" />
                              </div>
                            </div>
                            <dt>Data de partida:</dt>
                            <dd>{convertDateTimeToPtBRWithYear(item.startDate)}</dd>
                            <div onClick={() => props.setOnCenterMarkerPosition(RouteAddressType.FINAL)}>
                              <span>
                                <dt>Endereço de chegada:</dt>
                                <dd>{infoRouteDetail.finalPlace}</dd>
                              </span>
                              <div>
                                <img src="content/images/map-icons/icon_dot_final.png" alt="Ícone de chegada" />
                              </div>
                            </div>
                            <dt>Data de chegada:</dt>
                            <dd>{convertDateTimeToPtBRWithYear(item.finalDate)}</dd>

                            {item.driver ? (
                              <>
                                <dt>Motorista:</dt>
                                <dd>
                                  {item.driver.firstName} {item.driver.lastName}
                                </dd>
                              </>
                            ) : null}

                            {infoRouteDetail.maxSpeed ? (
                              <>
                                <dt>Velocidade máxima:</dt>
                                <dd>{infoRouteDetail.maxSpeed} km/h</dd>
                              </>
                            ) : null}

                            {infoRouteDetail.avgSpeed ? (
                              <>
                                <dt>Velocidade média:</dt>
                                <dd>{infoRouteDetail.avgSpeed} km/h</dd>
                              </>
                            ) : null}

                            {infoRouteDetail.distance ? (
                              <>
                                <dt>Distância percorrida:</dt>
                                <dd>{infoRouteDetail.distance} km</dd>
                              </>
                            ) : null}

                            {infoRouteDetail.startPlace && infoRouteDetail.finalPlace ? (
                              <>
                                <dt>Tempo total de rota:</dt>
                                <dd>{differenceBetweenTwoDates(item.finalDate, item.startDate, false)}</dd>
                              </>
                            ) : null}

                            {infoRouteDetail.totalIdleTimeInSeconds ? (
                              <>
                                <dt>Tempo total ocioso:</dt>
                                <dd>{formatIdleTime(infoRouteDetail.totalIdleTimeInSeconds)}</dd>
                              </>
                            ) : null}

                            {infoRouteDetail.avgFuelConsumption ? (
                              <>
                                <dt>Consumo combustível (Média):</dt>
                                <dd>{infoRouteDetail.avgFuelConsumption} km/l</dd>
                              </>
                            ) : null}
                          </dl>

                          {infoRouteDetail.idlePositions?.length > 0 && (
                            <Button
                              className="alerts-journey-button"
                              outline
                              onClick={() => [props.setIdlePositions(infoRouteDetail.idlePositions), props.setRenderMarkerIdlePosition(prev => !prev)]}
                            >
                              Ociosidade <HourglassBottomRounded fontSize="small" />
                            </Button>
                          )}
                          {item.totalAlerts > 0 && (
                            <Button
                              className="alerts-journey-button mr-2"
                              outline
                              onClick={() => [
                                filterTypesInfractions(props.listInfractions),
                                !allInfractions?.length && getInfractions(item.startDate, item.finalDate),
                                setIsOpen(true),
                              ]}
                            >
                              Alertas <FmdBadRounded fontSize="small" />
                            </Button>
                          )}
                          <Modal isOpen={isOpen}>
                            <ModalHeader toggle={() => setIsOpen(prevOpen => !prevOpen)}>Selecione os alertas</ModalHeader>
                            {allTypesInfractions?.length ? (
                              <Fragment>
                                <ModalBody>
                                  {allTypesInfractions.map((alert: IMapAlert, key) => (
                                    <section className="container-alerts" key={key}>
                                      <span>
                                        <span>
                                          {alert.label}
                                          {'   -   '}
                                        </span>
                                        <span>
                                          {alert.value} {alert.value > 1 ? 'alertas' : 'alerta'}
                                        </span>
                                      </span>
                                      <Checkbox
                                        className="checkbox-report"
                                        checked={filteredTypesInfractions.find(infracName => infracName === alert.label) ? true : false}
                                        onChange={(_, checked) => setAlertName(checked, alert.label)}
                                      />
                                    </section>
                                  ))}
                                </ModalBody>
                                <ModalFooter>
                                  <Button color="secondary" outline onClick={() => setIsOpen(prevOpen => !prevOpen)}>
                                    Cancelar
                                  </Button>
                                  <Button color="primary" onClick={() => filterInfractions(filteredTypesInfractions)}>
                                    Salvar
                                  </Button>
                                </ModalFooter>
                              </Fragment>
                            ) : (
                              <Loading noTheme />
                            )}
                          </Modal>
                        </Fragment>
                      ) : (
                        <Loading noTheme />
                      )}
                    </CardBody>
                  </Collapse>
                </Card>
              </div>
            </li>
          </ul>
        ))}

        {showReportButton && (
          <Button className="alerts-journey-button" outline onClick={getExcelFromInfoRoutes} disabled={disableReportButton}>
            {!disableReportButton ? 'Baixar relatório ' : 'Carregando relatório... '}
            <DownloadForOffline fontSize="small" />
          </Button>
        )}
      </Col>
    </NavDropdown>
  );
};
